import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=2c1f6bf5&scoped=true&"
import script from "./UserDetails.vue?vue&type=script&lang=js&"
export * from "./UserDetails.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./UserDetails.vue?vue&type=style&index=1&lang=css&"
import style2 from "./UserDetails.vue?vue&type=style&index=2&id=2c1f6bf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f6bf5",
  null
  
)

export default component.exports